<div class="provider-section-grid provider-address-grid" [formGroup]="formGroup">
  <div class="provider-section-header">
    <h5 class="section-title">{{ showReviewStatus ? 'Personal Address' : 'Provider Details' }}</h5>
  </div>
  <div class="provider-section-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="personalAddress1" class="field-label">Street Address</label>
      <mat-form-field class="provider-fields">
        <input
          id="personalAddress1"
          matInput
          type="text"
          placeholder="123 Main Street"
          class="user-record-field-input"
          formControlName="personalAddress1" />
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('personalAddress1')" />
    </div>
  </div>
  <div class="provider-section-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="personalAddress2" class="field-label">Street Address 2 (Optional)</label>
      <mat-form-field class="provider-fields">
        <input
          id="personalAddress2"
          matInput
          type="text"
          placeholder="Apt, Suite, etc."
          class="user-record-field-input"
          formControlName="personalAddress2" />
      </mat-form-field>
    </div>
  </div>
  <div class="provider-section-field half-width">
    <div class="user-record-field-wrapper">
      <label for="personalCity" class="field-label">City</label>
      <mat-form-field class="provider-fields">
        <input
          id="personalCity"
          matInput
          type="text"
          placeholder="City"
          class="user-record-field-input"
          formControlName="personalCity" />
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('personalCity')" [customErrorMessages]="cityErrorMessages" />
    </div>
  </div>
  <div class="provider-section-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="personalState" class="field-label">State</label>
      <mat-form-field class="provider-fields">
        <input
          id="personalState"
          matInput
          type="text"
          placeholder="State"
          class="user-record-field-input"
          formControlName="personalState"
          [matAutocomplete]="stateAuto" />
        <mat-autocomplete #stateAuto="matAutocomplete" [displayWith]="displayStateName">
          @for (state of filteredStates | async; track state) {
            <mat-option [value]="state">{{ state.name }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('personalState')" />
    </div>
  </div>
  <div class="provider-section-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="personalZip" class="field-label">Zip Code</label>
      <mat-form-field class="provider-fields">
        <input
          id="personalZip"
          matInput
          type="text"
          maxlength="5"
          placeholder="12345"
          class="user-record-field-input"
          formControlName="personalZip"
          [attr.aria-describedby]="formGroup.get('personalZip')?.invalid && formGroup.get('personalZip')?.touched ? 'personalZip-error' : null" />
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('personalZip')" />
    </div>
  </div>
  @if (isPersonalNorthCarolina()) {
    <div class="provider-section-field quarter-width">
      <div class="user-record-field-wrapper">
        <label for="tutorPersonalCounty" class="field-label">County</label>
        <mat-form-field class="provider-fields">
          <input
            id="tutorPersonalCounty"
            matInput
            type="text"
            placeholder="County"
            class="user-record-field-input"
            formControlName="personalCounty"
            [matAutocomplete]="countyAutoTutor" />
          <mat-autocomplete #countyAutoTutor="matAutocomplete">
            @for (county of filteredCounties | async; track county.name) {
              <mat-option [value]="county.name">{{ county.name }}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <cfi-form-inline-error [control]="formGroup.get('personalCounty')" />
      </div>
    </div>
  }
  <div class="provider-section-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="tutorPhone" class="field-label">Phone Number</label>
      <mat-form-field class="provider-fields">
        <input
          id="tutorPhone"
          matInput
          type="text"
          placeholder="(123) 456-7890"
          [mask]="'(000) 000-0000'"
          formControlName="phone"
          class="user-record-field-input"
          [dropSpecialCharacters]="false"
          [attr.aria-describedby]="formGroup.get('phone')?.invalid && formGroup.get('phone')?.touched ? 'tutorPhone-error' : null" />
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('phone')" />
    </div>
  </div>
  <div class="provider-section-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="tutorSecondaryPhone" class="field-label">Secondary Phone Number</label>
      <mat-form-field class="provider-fields">
        <input
          id="tutorSecondaryPhone"
          matInput
          type="text"
          placeholder="(123) 456-7890"
          [mask]="'(000) 000-0000'"
          formControlName="secondaryPhone"
          class="user-record-field-input"
          [dropSpecialCharacters]="false" />
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('secondaryPhone')" />
    </div>
  </div>
  <div class="provider-section-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="tutorBirthDate" class="field-label">Date of Birth</label>
      <mat-form-field class="provider-fields">
        <input
          id="tutorBirthDate"
          matInput
          [matDatepicker]="birthDatePicker"
          (click)="birthDatePicker.open()"
          placeholder="MM/DD/YYYY"
          class="user-record-field-input"
          formControlName="birthDate" />
        <mat-datepicker-toggle matIconSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #birthDatePicker startView="multi-year"></mat-datepicker>
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('birthDate')" />
    </div>
  </div>
  <div class="provider-section-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="socialSecurityLast4" class="field-label">Social Security Number</label>
      <lib-ssn-field
        id="socialSecurityLast4"
        [control]="socialSecurityControl"
        [ariaErrorId]="
          formGroup.get('socialSecurityLast4')?.invalid && formGroup.get('socialSecurityLast4')?.touched
            ? 'socialSecurityLast4-error'
            : null">
      </lib-ssn-field>
      <cfi-form-inline-error [control]="formGroup.get('socialSecurityLast4')" />
    </div>
  </div>
  <div class="provider-section-field half-width">
    <div class="user-record-field-wrapper">
      <label for="schoolName" class="field-label">School Name</label>
      <mat-form-field class="provider-fields">
        <input
          id="schoolName"
          matInput
          type="text"
          placeholder="School Name"
          class="user-record-field-input"
          formControlName="schoolName"
          [matAutocomplete]="schoolAuto" />
        <mat-autocomplete #schoolAuto="matAutocomplete" (optionSelected)="onSchoolSelected($event)">
          @for (school of filteredSchoolOptions | async; track school.id) {
            <mat-option [value]="school">{{ formatSchoolLabel(school) }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('schoolName')" />
    </div>
  </div>
  <div class="provider-section-field half-width">
    <div class="user-record-field-wrapper">
      <label for="graduationDate" class="field-label">Graduation Date</label>
      <mat-form-field class="provider-fields">
        <input
          id="graduationDate"
          matInput
          [matDatepicker]="graduationDatePicker"
          (click)="graduationDatePicker.open()"
          placeholder="Graduation Date"
          class="user-record-field-input"
          formControlName="graduationDate" />
        <mat-datepicker-toggle matIconSuffix [for]="graduationDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #graduationDatePicker></mat-datepicker>
      </mat-form-field>
       <cfi-form-inline-error [control]="formGroup.get('graduationDate')" />
    </div>
  </div>
</div>
